import React from "react";

import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';

import { useStyles } from "common/Styles";

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';


const itemData = [
  {
    img: 'images/qrcode/evse_01.png',
    title: 'EVSE_01',
  },
  {
    img: 'images/qrcode/evse_02.png',
    title: 'EVSE_02',
  },
  {
    img: 'images/qrcode/evse_03.png',
    title: 'EVSE_03',
  },
  {
    img: 'images/qrcode/evse_04.png',
    title: 'EVSE_04',
  },
  {
    img: 'images/qrcode/evse_05.png',
    title: 'EVSE_05',
  },
  {
    img: 'images/qrcode/evse_06.png',
    title: 'EVSE_06',
  },
  {
    img: 'images/qrcode/evse_07.png',
    title: 'EVSE_07',
  },
  {
    img: 'images/qrcode/evse_08.png',
    title: 'EVSE_08',
  },
  {
    img: 'images/qrcode/evse_09.png',
    title: 'EVSE_09',
  },
  {
    img: 'images/qrcode/evse_10.png',
    title: 'EVSE_10',
  },
  {
    img: 'images/qrcode/evse_11.png',
    title: 'EVSE_11',
  },
  {
    img: 'images/qrcode/evse_12.png',
    title: 'EVSE_12',
  },
];



const QRCodeSamples = (props) => {
  const classes = useStyles();


  return (

    <div className={classes.root}>

      <Card
        raised={false}
        style={{
          alignItems: "flex-start",
          // padding:theme.spacing(1)
        }}
      >

        <CardHeader align="center"
          title={<Typography variant="h5">QRCode Samples</Typography>}
          style={{
            borderBottom: "thick double darkgray",
            // marginBottom: "10px", // Adjust the margin as needed
            // paddingTop: "0", // Set padding-top to 0
            marginInline: "2em",
            backgroundColor: "lightgray",
            // paddingTop: "10px",
            marginTop: "10px",
          }}
        />


        <CardContent >
          <Grid container item md={12} xs={12} spacing={1} direction="row" alignItems="center" style={{ marginBlock: "10px" }}>

            <ImageList cols={4}
            // sx={{ width: 500, height: 450 }}
            >
              {itemData.map((item) => (
                <ImageListItem key={item.img}>
                  <img
                    // srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                    // src={`${item.img}?w=248&fit=crop&auto=format`}
                    srcSet={`${item.img}?fit=crop&auto=format&dpr=2 2x`}
                    src={`${item.img}?fit=crop&auto=format`}
                    alt={item.title}
                    loading="lazy"
                  />
                  <ImageListItemBar
                    title={item.title}
                    // subtitle={<span>by: {item.author}</span>}
                    position="below"
                    align="center"
                  />
                </ImageListItem>
              ))}
            </ImageList>

          </Grid>
        </CardContent>

      </Card>
    </div>
  )
}


export default QRCodeSamples;

